<template>
  <div class="content">
    <div class="card-box data-table">
      <div class="inp-list">
        <div class="item">
          <span class="label">{{ $t('decision.time') }}</span>
          <el-date-picker class="inp" v-model="formData.valTime" value-format="YYYY-MM-DD" size="small" type="daterange"
            unlink-panels :range-separator="$t('g.to')" :start-placeholder="$t('g.start_date')"
            :end-placeholder="$t('g.end_date')" :shortcuts="render.shortcuts">
          </el-date-picker>
        </div>
        <div class="item">
          <span class="label">{{ $t('g.operator') }}</span>
          <el-cascader size="small" style="width: 100%;flex: 1;" :clearable="true" v-model="formData.CodePathID"
            :props="formData.props" :options="render.cascade_options_direct" />
        </div>
        <div class="item">
          <span class="label">{{ $t('member.status') }}</span>
          <el-select class="inp" size="small" v-model="formData.valStatus" :placeholder="$t('g.choose')">
            <el-option v-for="item in render.statuses" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>

        <div class="item">
          <span class="label">{{ $t('order.name') }}</span>
          <el-input class="inp" size="small" v-model="formData.valTel" :placeholder="$t('order.inp.name')"></el-input>
        </div>
        <div class="item">
          <span class="label">{{ $t('g.name') }}</span>
          <el-input class="inp" size="small" v-model="formData.idName" :placeholder="$t('g.enter_name')"></el-input>
        </div>
        <div class="item">
          <span class="label">{{ $t('member.mobile') }}</span>
          <el-input class="inp" size="small" v-model="formData.valPhone" :placeholder="$t('member.mobile')"></el-input>
        </div>

      </div>
      <div class="btn-ct">
        <el-button @click="func.exportAllExcel()" class="btn-export" type="info">{{ $t('g.export') }}</el-button>
        <el-button @click="func.search" class="search" type="primary">{{ $t('g.search') }}</el-button>
      </div>
      <div class="line"></div>
      <el-table :data="formData.tableData" @row-click="func.showDetails" style="width: 100%"
        :summary-method="func.getSummaries" show-summary>
        <el-table-column prop="Id" label="ID" width="100">
        </el-table-column>
        <el-table-column prop="OrderSn" :label="$t('order.no')" width="200">
        </el-table-column>
        <el-table-column prop="AgentCode" :label="$t('g.agent_code')" width="100">
        </el-table-column>
        <el-table-column prop="UserInfo.Mobile" width="120" :label="$t('member.mobile')">
        </el-table-column>
        <el-table-column prop="UserInfo.Nickname" width="100" :label="$t('bill.nickname')">
        </el-table-column>
        <el-table-column prop="UserInfo.IdName" width="100" :label="$t('member.IdName')">
        </el-table-column>
        <el-table-column width="100" :label="$t('member.status')">
          <template #default="scope">
            <el-tag
              :class="scope.row.StatusStr == $t('member.statuses.success') ? 'tag-success' : (scope.row.StatusStr == $t('member.statuses.failed') ? 'tag-fail' : 'tag-warning')">
              {{ scope.row.StatusStr }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column width="120" :label="$t('order.combo.profit_status')">
          <template #default="scope">
            <el-tag v-if="scope.row.ShareStatus == -1" class="tag-info">{{ $t('order.combo.no_profit') }}</el-tag>
            <el-tag v-if="scope.row.ShareStatus == 0">{{ $t('order.combo.waiting_profit') }}</el-tag>
            <el-tag v-if="scope.row.ShareStatus == 1" class="tag-success">{{ $t('order.combo.profits_divided')
            }}</el-tag>
            <el-tag v-if="scope.row.ShareStatus == 2" class="tag-info">{{ $t('order.combo.in_progress') }}</el-tag>
            <el-tag v-if="scope.row.ShareStatus == 3" class="tag-fail">{{ $t('order.combo.failure_sharing') }}</el-tag>
            <el-tag v-if="scope.row.ShareStatus == 4" class="tag-warning">{{ $t('order.combo.Fallback') }}</el-tag>
            <el-tag v-if="scope.row.ShareStatus == 5" class="tag-fail">{{ $t('order.combo.rolled_back') }}</el-tag>
            <el-tag v-if="scope.row.ShareStatus == 6" class="tag-fail">{{ $t('order.combo.rollback_failed') }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="ComboOrder.Combo.Name" width="130" :label="$t('expenses.name')">
        </el-table-column>
        <el-table-column width="100" :label="$t('order.combo.price')">
          <template #default="scope">
            {{ scope.row.ComboOrder?.Money || scope.row.OrderPrice }}
          </template>
        </el-table-column>
        <el-table-column prop="PayMoneyActual" width="80" :label="$t('order.combo.actualAmount')">
        </el-table-column>
        <el-table-column prop="DeduCouponMoney" width="100" :label="$t('order.combo.couponDiscount')">
        </el-table-column>
        <el-table-column prop="PayWayStr" width="100" :label="$t('order.pay_way')">
        </el-table-column>
        <el-table-column prop="ComboTypetxt" width="100" :label="$t('order.combo_type')">
        </el-table-column>
        <el-table-column width="110" :label="$t('order.overdueDay')">
          <template #default="scope">
            {{ scope.row.ComboOrder?.OverdueDay ? scope.row.ComboOrder?.OverdueDay + '天' : '无' }}
          </template>
        </el-table-column>
        <el-table-column prop="Remark" width="140" :label="$t('order.remark')">
        </el-table-column>
        <el-table-column prop="NamePath" min-width="180" :label="$t('g.operator_ownership')"
          :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="CreatedAtStr" width="180" :label="$t('g.create_at')">
        </el-table-column>
        <el-table-column prop="EndAtStr" min-width="180" :label="$t('card.expire')">
        </el-table-column>
        <el-table-column width="200" :label="$t('g.operation')" fixed="right">
          <template #default="scope">
            <el-button @click="func.onRefund(scope.row)"
              :class="scope.row.Status == 1 && (scope.row.PayWay == 2 || scope.row.PayWay == 1) ? 'btn-add' : 'tag-info'"
              type="info" :disabled="scope.row.Status != 1 || (scope.row.PayWay != 2 && scope.row.PayWay != 1)">{{
                $t("home.Refund") }}</el-button>
            <el-button v-if="scope.row.ShareStatus != -1" :class="scope.row.ShareStatus == 0 ? 'tag-info' : ' btn-add'"
              :disabled="scope.row.ShareStatus == 0" @click="func.showSeparate(scope.row)"
              type="primary">分账详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <div class="title">{{ $t("g.unit_num") }}:{{ formData.total }}，{{ $t("g.per_page") }}:{{ formData.pageSize }}
        </div>
        <el-pagination background layout="prev, pager, next" @current-change="func.pageChange"
          :page-size="formData.pageSize" :current-page="formData.curPage" :total="formData.total">
        </el-pagination>
      </div>
    </div>
    <el-dialog :title="$t('g.detail')" v-model="formData.dialogDisplayVisible" align-center width="90%">
      <el-descriptions border column="3">
        <el-descriptions-item :label="$t('order.no')">{{ formData.curData.OrderSn }}</el-descriptions-item>
        <el-descriptions-item :label="$t('g.agent_code')" v-if="!isOperator()">{{ formData.curData.AgentCode
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('member.mobile')"> <el-link type="primary"
            @click="formData.userDrawerVisible = true">{{ formData.curData.UserInfo?.Mobile
            }}</el-link></el-descriptions-item>
        <el-descriptions-item :label="$t('bill.nickname')">
          <el-link type="primary" @click="formData.userDrawerVisible = true">{{ formData.curData.UserInfo?.Nickname
          }}</el-link>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('member.IdName')"> <el-link type="primary"
            @click="formData.userDrawerVisible = true">{{ formData.curData.UserInfo?.IdName
            }}</el-link></el-descriptions-item>
        <el-descriptions-item :label="$t('expenses.name')">
          <el-link type="primary" @click="formData.comboDrawerVisible = true">{{ formData.curData.ComboOrder?.Combo.Name
          }}</el-link>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('order.combo.price')">{{ formData.curData.ComboOrder.Money
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('order.combo.actualAmount')">{{ formData.curData.ComboOrder.PayMoney
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('order.combo.cashDiscount')">{{
          formData.curData.ComboOrder.DeduPullMoney }}</el-descriptions-item>
        <el-descriptions-item :label="$t('order.combo.couponDiscount')">{{ formData.curData.ComboOrder.DeduCouponMoney
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('order.combo.RefundAmount')">{{ formData.curData.RefundMoney
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('order.pay_way')">{{ formData.curData.PayWayStr }}</el-descriptions-item>
        <el-descriptions-item :label="$t('order.combo_type')">{{ formData.curData.ComboTypetxt
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('order.overdueDay')">{{ formData.curData.ComboOrder?.OverdueDay
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('device.pattern')">{{ formData.curData.ComboOrder.DevType
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('order.remark')">{{ formData.curData.Remark
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('member.status')"> <el-tag
            :class="formData.curData.StatusStr == $t('member.statuses.success') ? 'tag-success' : (formData.curData.StatusStr == $t('member.statuses.failed') ? 'tag-fail' : 'tag-warning')">
            {{ formData.curData.StatusStr }}
          </el-tag></el-descriptions-item>
        <el-descriptions-item :label="$t('order.comboType')">{{
          formData.curData.ComboOrder?.RentOrderNum ? $t('order.rentAndCombo') : $t('order.commonCombo')
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('g.create_at')">{{ formData.curData.CreatedAtStr }}</el-descriptions-item>
        <el-descriptions-item :label="$t('g.operator_ownership')">{{ formData.curData.NamePath }}</el-descriptions-item>
        <el-descriptions-item :label="$t('card.expire')">{{ formData.curData.EndAtStr }}</el-descriptions-item>
        <!-- <el-descriptions-item :label="$t('card.expire')">{{ formData.curData.EndAtStr }}</el-descriptions-item>
        <el-descriptions-item label="账单类型">常规或分账</el-descriptions-item>
        <el-descriptions-item label="分账接收方商户号后6位">000670</el-descriptions-item>
        <el-descriptions-item label="分账接收方">麦迪瑞公司</el-descriptions-item>
        <el-descriptions-item label="分账接收方金额">30元</el-descriptions-item>
        <el-descriptions-item label="分账比例">9%</el-descriptions-item>
        <el-descriptions-item label="分账方金额">159元</el-descriptions-item>
        <el-descriptions-item label="微信资金状态">冻结或解冻</el-descriptions-item>
        <el-descriptions-item label="分账状态">未提交，已提交、申请成功、分账完成、已回退</el-descriptions-item> -->
      </el-descriptions>
    </el-dialog>
    <el-dialog title="退款" v-model="formData.dialogRefundVisible" align-center>
      <el-form label-width="100px" :model="formData.curData">
        <div class="el-form-row line-2">
          <el-form-item label="退款金额" style="width: 340px">
            <el-input v-model="formData.curData.refundAmount" placeholder="请输入退款金额">
            </el-input>
          </el-form-item>
          <el-form-item label="输入密码" style="width: 340px">
            <el-input v-model="formData.curData.password" type="password" placeholder="请输入密码">
            </el-input>
          </el-form-item>
        </div>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="func.refund()">{{ $t('g.btn_confirm') }}</el-button>
        </span>
      </template>
    </el-dialog>
    <el-dialog title="分账详情" v-model="formData.SeparateVisible" align-center>
      <el-descriptions border :column="2" v-for="item in formData.account_details" style="margin-top: 20px;">
        <el-descriptions-item label="ID">{{ item.Id }}</el-descriptions-item>
        <el-descriptions-item label="分账接收账方">{{ item.RXAgentName
        }}</el-descriptions-item>
        <el-descriptions-item label="分账接收金额">{{ item.ShareMoney / 100
        }}</el-descriptions-item>
        <el-descriptions-item label="分账状态">
          <el-tag v-if="item.ShareStatus == 0">未分账</el-tag>
          <el-tag v-if="item.ShareStatus == 1" class="tag-success">已分账</el-tag>
          <el-tag v-if="item.ShareStatus == 2" class="tag-info">分账中</el-tag>
          <el-tag v-if="item.ShareStatus == 3" class="tag-fail">分账失败</el-tag>
          <el-tag v-if="item.ShareStatus == 4" class="tag-warning">分账回退中</el-tag>
          <el-tag v-if="item.ShareStatus == 5" class="tag-fail">分账已回退</el-tag>
          <el-tag v-if="item.ShareStatus == 6" class="tag-fail">分账回退失败</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="分账时间">{{ item.WXFinishTime
        }}</el-descriptions-item>
        <el-descriptions-item label="备注">{{ item.ShareRemark
        }}</el-descriptions-item>
        <el-descriptions-item label="操作" v-if="formData.showType">
          <el-button :class="formData.refundInfo.Status != 2 || item.ShareStatus != 1 ? 'tag-info' : ' btn-add'"
            :disabled="formData.refundInfo.Status != 2 || item.ShareStatus != 1" @click="func.separate_refund(item)"
            type="primary">分账回退</el-button>
        </el-descriptions-item>
      </el-descriptions>
    </el-dialog>
    <el-drawer v-model="formData.userDrawerVisible" size="80%" :with-header="true" :destroy-on-close="true"
      :title="$t('g.detail')">
      <MemberList :propId="formData.curData.UserInfo.Id"></MemberList>
    </el-drawer>
    <el-drawer v-model="formData.comboDrawerVisible" size="80%" :with-header="true" :destroy-on-close="true"
      :title="$t('g.detail')">
      <ExpensesCombo :propId="formData.curData.ComboOrder?.Combo.Name"></ExpensesCombo>
    </el-drawer>
  </div>
</template>

<script>
import { reactive, onMounted } from 'vue'
import axios from 'axios'
import { operators, updateOperators, shortcuts, cascade_options_direct } from '@/data/default'
import { toDay } from "@/common/func"
import i18n from '@/data/i18n/index'
import { isOperator } from '@/data/token'
import { ElMessage, ElMessageBox, ElLoading } from 'element-plus'
import * as XLSX from 'xlsx/xlsx.mjs'
import MemberList from '@/views/member/list.vue'
import ExpensesCombo from '@/views/expenses/combo.vue'
export default {
  name: 'OrderComboList',
  components: {
    MemberList,
    ExpensesCombo
  },
  props: {
    propId: String,
  },
  setup(props) {
    const t = i18n.global.t
    const tableData = []
    const statuses = [
      {
        label: t('member.statuses.all'),
        value: -1
      },
      {
        label: t('member.statuses.unpay'),
        value: 0
      },
      {
        label: t('member.statuses.paid'),
        value: 1
      },
      {
        label: '已退款',
        value: 2
      },
      {
        label: '退款中',
        value: 3
      },
      {
        label: '退款失败',
        value: 4
      },
    ]
    const render = {
      shortcuts,
      statuses,
      operators,
      cascade_options_direct
    }
    const formData = reactive({
      tableData,
      curData: {},
      CodePathID: 0,
      valStatus: -1,
      dialogDisplayVisible: false,
      dialogRefundVisible: false,
      userDrawerVisible: false,
      comboDrawerVisible: false,
      SeparateVisible: false,
      valTime: '',
      valTel: '',
      // pagination
      curPage: 1,
      pageSize: 10,
      total: 1,
      props: {
        children: "Children", expandTrigger: 'hover',
        label: "Name",
        value: "Id",
        emitPath: false,
        checkStrictly: true
      },
      IsStartWith: 1,
      account_details: [],
      refundInfo: {},
      showType: true,
    })
    const func = {
      getSummaries(options) {
        const { columns, data } = options;
        // console.log(JSON.stringify(data), 820);

        const sums = [];
        columns.forEach((column, index) => {
          // console.log(JSON.stringify(column), 20);

          if (index === 0) {
            sums[index] = t("g.total");
            return;
            //index === 22 || index === 24 || index === 28  这是表格第几列需要合计值
            // 例如只需要第3列的值求和，index===3
          } else if (index === 8 || index === 10) {
            // let tmp = column.property.split('.');
            const values = data.map((item) => Number(item[column.property]));

            console.log(JSON.stringify(values), 238);

            sums[index] = values.reduce((prev, curr) => {
              console.log(JSON.stringify(curr), 2830);

              const value = Number(curr);
              // console.log(JSON.stringify(value),23980);
              if (!isNaN(value)) {
                return Math.floor((prev + curr) * 100) / 100;
              } else {
                return prev;
              }
            }, 0) + t('card.currency');
          }
        });

        return sums;
      },
      async exportAllExcel() {
        let loading = ''
        try {
          let params = {
            isExport: true
          }
          if (formData.CodePathID) {
            params.agentcode = formData.CodePathID
          }
          if (formData.valTel) {
            params.nickname = formData.valTel
          }
          if (formData.valStatus != -1) {
            params.status = formData.valStatus
          }
          if (formData.valPhone) {
            params.phoneNum = formData.valPhone
          }
          if (formData.idName) {
            params.idName = formData.idName
          }
          if (formData.valTime) {
            params.startAt = Math.floor(Date.parse(formData.valTime[0] + " 00:00:00") / 1000)
            params.endAt = Math.floor(Date.parse(formData.valTime[1] + " 23:59:59") / 1000)
          }

          loading = ElLoading.service({
            lock: true,
            text: t('openSlotsLit.loading'),
            background: 'rgba(0, 0, 0, 0.7)',
          })
          let res = await axios.get(`/admin/order/combo`, {
            params
          })
          let excleData = [[]];
          let wscols = [];
          excleData = [[
            'ID',
            '订单号',
            '套餐名称',
            '类型',
            '价格',
            '实付金额',
            '优惠券抵扣',
            '支付方式',
            '号码',
            '昵称',
            '姓名',
            '状态',
            '备注',
            '时间',
          ]];
          const dictType = [
            t('openSlotsLit.result.success'),
            t('openSlotsLit.result.fail'),
          ]
          wscols = [    // 每列不同宽度px
            { wch: 10 },
            { wch: 20 },
            { wch: 15 },
            { wch: 10 },
            { wch: 10 },
            { wch: 10 },
            { wch: 10 },
            { wch: 10 },
            { wch: 20 },
            { wch: 15 },
            { wch: 12 },
            { wch: 12 },
            { wch: 22 },
            { wch: 22 },

          ];
          if (res && res.List) {
            for (let item of res.List) {
              let arr = [];
              arr = [
                item.Id,
                item.OrderSn,
                item.ComboOrder.Combo.Name,
                item.ComboOrder.Combo.Type == 1 ? item.ComboOrder.Combo.Num + t('order.unit_months') : item.ComboOrder.Combo.Type == 2 ? item.ComboOrder.Combo.Num + t('order.unit_times') : item.ComboOrder.Combo.Num + '天',
                item.ComboOrder.Money,
                item.ComboOrder.PayMoney,
                item.ComboOrder.DeduCouponMoney,
                item.PayWay == 1 ? t('order.pay_ways.balance') : item.PayWay == 2 ? t('order.pay_ways.wechat') : item.PayWay == 5 ? t('order.pay_ways.alipay') : item.PayWay == 8 ? t('order.pay_ways.meiTuan') : '',
                item.UserInfo.Mobile,
                item.UserInfo.Nickname,
                item.UserInfo.IdName,
                item.Status === 1 ? '成功' : '未支付',
                item.Remark,
                toDay(item.CreatedAt),
              ]
              excleData.push(arr)
            }
          }
          const worksheet = XLSX.utils.aoa_to_sheet(excleData);
          worksheet["!cols"] = wscols;
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
          XLSX.writeFile(workbook, '换电套餐订单' + '.xlsx');
          loading.close()
        } catch (err) {
          loading.close()

        }
      },
      async showSeparate(row) {
        formData.refundInfo = row
        let params = {
          Id: row.Id
        }
        let res = await axios.get('/admin/order/profitshare', {
          params
        }
        )
        res.List.map((item) => {
          item.WXFinishTime = item.WXFinishTime.replace('T', ' ');
        })
        formData.account_details = res.List
        formData.SeparateVisible = true

      },
      async separate_refund(item) {
        ElMessageBox.confirm('是否确认分账回退？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let params = {
            Id: item.Id,
            Remark: '订单资金回退'
          }
          try {
            let res = await axios.post('/admin/share/sharingrefund', params)
            ElMessage({
              type: 'success',
              message: res
            })
          } catch (e) {
            console.log("分账回退失败", e)
          }
          formData.SeparateVisible = false
          func.loadData()
        }).catch(() => {
        });
      },
      onRefund(row) {
        formData.curData = row;
        formData.dialogRefundVisible = true
      },
      async refund(row) {
        // ElMessageBox.prompt('输入退款备注信息', '确认退款', {
        //   confirmButtonText: '确定',
        //   cancelButtonText: '取消',
        //   type: 'warning'
        // }).then(async ({ value }) => {
        let params = {
          ComboOrderID: formData.curData.OrderSn,
          Money: formData.curData.refundAmount
        }
        if (!formData.curData.refundAmount) {
          return ElMessage({
            type: 'error',
            message: '请输入退款金额'
          })
        }
        if (formData.curData.password) {
          params.Password = formData.curData.password
        } else {
          return ElMessage({
            type: 'error',
            message: '请输入密码'
          })
        }
        try {
          let res = await axios.post('/admin/user/refundcombomoney', params)
          ElMessage({
            type: 'success',
            message: res
          })
          // console.log(JSON.stringify(res), 238);

          formData.dialogRefundVisible = false
          func.loadData()
        } catch (e) {
          // console.log(JSON.stringify(e), 23812);

        }

      },
      showDetails(row, column) {
        if (column && column.label == t('g.operation')) {
          return;
        }
        formData.dialogDisplayVisible = true;
        formData.curData = row;
      },
      search() {
        console.log('formData', formData)
        func.loadData(1)
      },
      pageChange(val) {
        console.log('page change', val)
        func.loadData(val)
      },
      refresh() {
        formData.CodePathID = 0
        formData.valStatus = -1
        formData.valTime = ''
        formData.valTel = ''
        func.loadData(1)
      },
      async loadData(page = 1) {
        try {
          formData.tableData = []
          formData.curPage = page
          let params = {
            page,
          }
          if (formData.CodePathID) {
            params.CodePathID = formData.CodePathID
          }
          if (props.propId) {
            formData.valTel = props.propId
          }
          if (formData.valTel) {
            params.nickname = formData.valTel
          }
          if (formData.idName) {
            params.idName = formData.idName
          }
          if (formData.valStatus != -1) {
            params.status = formData.valStatus
          }
          if (formData.valPhone) {
            params.phoneNum = formData.valPhone
          }
          if (formData.valTime) {
            params.startAt = Math.floor(Date.parse(formData.valTime[0] + " 00:00:00") / 1000)
            params.endAt = Math.floor(Date.parse(formData.valTime[1] + " 23:59:59") / 1000)
          }
          params.IsStartWith = formData.IsStartWith
          let res = await axios.get(`/admin/order/combo`, {
            params
          })
          formData.total = res.Total
          res.List.map((item) => {
            item.CreatedAtStr = toDay(item.CreatedAt)
            switch (item.Status) {
              case 0:
                item.StatusStr = '未支付'
                break;
              case 1:
                item.StatusStr = t('member.statuses.success')
                break;
              case 2:
                item.StatusStr = '已退款'
                break;
              case 3:
                item.StatusStr = '退款中'
                break;
              case 4:
                item.StatusStr = '退款失败'
                break;
              default:
                item.StatusStr = t('member.statuses.failed')
            }
            // item.StatusStr = item.Status === 1 ? t('member.statuses.success') : t('member.statuses.failed')
            item.PayWayStr = ""
            item.EndAtStr = item.ComboOrder?.EndAt ? toDay(item.ComboOrder.EndAt) : '';
            if (item.PayWay == 1) {
              item.PayWayStr = t('order.pay_ways.balance')
            } else if (item.PayWay == 2) {
              item.PayWayStr = t('order.pay_ways.wechat')
            } else if (item.PayWay == 4) {
              item.PayWayStr = t('order.pay_ways.paypal')
            } else if (item.PayWay == 5) {
              item.PayWayStr = t('order.pay_ways.alipay')
            } else if (item.PayWay == 8) {
              item.PayWayStr = t('order.pay_ways.meiTuan')
            } else if (item.PayWay == 9) {
              item.PayWayStr = t('order.pay_ways.pdcother')
            }
            item.PayMoneyActual = item.ComboOrder?.PayMoney
            item.DeduCouponMoney = item.ComboOrder?.DeduCouponMoney
            //套餐类型
            if (item.ComboOrder?.Combo.Type == 2) {
              item.ComboTypetxt = item.ComboOrder?.Combo.Num + " " + t('order.unit_times')
            } else if (item.ComboOrder?.Combo.Type == 1) {
              item.ComboTypetxt = item.ComboOrder?.Combo.Num + " " + t('order.unit_months')
            } else if (item.ComboOrder?.Combo.Type == 3) {
              item.ComboTypetxt = item.ComboOrder?.Combo.Num + " " + t('common.days')
            }
          })
          formData.tableData = res.List
          formData.pageSize = res.PageSize
        } catch (e) {
          console.log("loadData", e)
        }
      }
    }
    onMounted(() => {
      console.log("onMounted")
      //updateOperators()
      func.loadData()
      if (localStorage.getItem('user_info')) {
        let user_info = JSON.parse(localStorage.getItem('user_info'))
        if (user_info.CodePath && user_info.CodePath.includes('RDCX')) {
          formData.showType = false
        }
      }
    })
    return {
      func,
      render,
      formData,
      isOperator,
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  .inp-block {
    display: block;
  }

  >.card-box {
    font-size: 0.875rem;
    background-color: #fff;
    box-shadow: $box-shadow;
    box-sizing: border-box;
    padding: 1.25rem;
    border-radius: 0.3rem;
    margin-bottom: 1.25rem;

    .header {
      text-align: left;
      margin-bottom: 1.25rem;
      position: relative;

      >.title {
        font-size: 1rem;
        font-weight: 500;
      }

      >.header-icons {
        position: absolute;
        right: 10px;
        top: 0px;
        z-index: 100;

        .header-icon {
          font-size: 0.875rem;
          font-weight: 500;
          border: 1px solid #ddd;
          color: #969696;
          padding: 0.25rem;
          border-radius: 50%;
          color: pointer;
          margin-left: 0.625rem;
          cursor: pointer;
        }
      }
    }
  }

  >.el-alert-my {
    margin-bottom: 1.25rem;
    box-shadow: $box-shadow;
    padding: 1.25rem;

    .el-alert-my-txt {
      font-size: 0.875rem;

      >.tips {
        font-weight: bold;
      }
    }

    :deep(.el-alert__closebtn) {
      top: 1.25rem;
      font-size: 1rem;
    }
  }

  >.data-table {
    :deep(.el-table) {
      .cell {
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .el-table__row {
        cursor: pointer;
      }
    }
  }


  .el-form-row {
    display: flex;
    justify-content: space-between;

    :deep(.el-form-item) {
      width: 49%;
    }
  }

  .el-select-my {
    text-align: left;
    display: block;
  }
}
</style>
